/**
 * Utilidades para el módulo Parámetros de Adelantos en Efectivo.
 */

/**
 * Valores de cuotas disponibles en el sistema.
 * @type {number[]}
 */
export const CUOTAS_DISPONIBLES = [1, 2, 3, 6, 9, 12, 18, 24];

/**
 * Monto máximo permitido para un adelanto en efectivo (en pesos argentinos).
 * @type {number}
 */
export const MONTO_MAXIMO = 1_000_000;

/**
 * Ordena un array de Reglas por `score_min` de forma ascendente,
 * colocando las reglas con `score_min === null` al final.
 *
 * No muta el array original; devuelve una copia ordenada.
 *
 * @param {Array<{score_min: number|null}>} reglas - Lista de reglas a ordenar.
 * @returns {Array<{score_min: number|null}>} Nueva lista ordenada.
 */
export function sortReglas(reglas) {
  return [...reglas].sort((a, b) => {
    if (a.score_min === null && b.score_min === null) return 0;
    if (a.score_min === null) return 1;
    if (b.score_min === null) return -1;
    return a.score_min - b.score_min;
  });
}
